import styled from '@emotion/styled'

import { LoadingIcon } from '@cash-design-system/react'

const LoadingContainer = styled.div<{ navbarRendered?: boolean }>`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  align-items: center;

  /* 4rem (header), doubled so the container centerpoint is the middle of the screen */
  height: ${({ navbarRendered }) => (navbarRendered ? 'calc(100dvh - 8rem)' : '100dvh')};
`
export function LoadingPage({ navbarRendered = false }) {
  return (
    <LoadingContainer data-testid="loading-icon" navbarRendered={navbarRendered}>
      <LoadingIcon />
    </LoadingContainer>
  )
}
